import {  Container} from "reactstrap";
import { Breadcrumbs } from "../../../AbstractElements";
import { BonusUi, Ribbons,} from "../../../Constant";
import LeftRibbons from "./LeftRibbons";
import RightRibbons from "./RightRibbon";

const RibbonsContainer = () => {
  return (
    <>
      <Breadcrumbs pageTitle={Ribbons} parent={BonusUi} title={Ribbons} />
      <Container fluid>
        <LeftRibbons/>
        <RightRibbons/>
      </Container>
    </>
  );
};

export default RibbonsContainer;
